import {createContext, useContext, useState} from "react";

const SessionExpiredContext = createContext({
    openSessionModal: false,
});

export const SessionExpiredProvider = ({children}) => {
    const [openSessionModal, setOpenSessionModal] = useState(false)


    return (
        <SessionExpiredContext.Provider value={{openSessionModal, setOpenSessionModal}}>
            {children}
        </SessionExpiredContext.Provider>
    )
}

export const useSessionExpired = () => useContext(SessionExpiredContext)
